import type { EntryRuleTracking } from '@tilelist/application/ports/EntryRuleTracking.ts';
import type { TileListLoaded } from '@tilelist/application/ports/TileListLoaded.ts';
import type { OnEx } from '@tilelist/domain/experiments/OnEx.ts';

export function createEntryRuleTrackingService(
    onex: OnEx,
    getEntryRule: () => string,
    tileListLoaded: TileListLoaded,
    entryRuleTracking: EntryRuleTracking,
): () => void {
    if (!onex.isToggleActive('REPTILE_1303_NAVIGATION_HISTORY')) return () => {};

    entryRuleTracking.trackEntryRule(getEntryRule());
    return tileListLoaded.onTileListLoaded(() => entryRuleTracking.trackEntryRule(getEntryRule()));
}
